import { useEffect, useState } from 'react';

export function useIsPrinting() {
  const [isPrinting, setIsPrinting] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;

    const mediaQueryList = window.matchMedia('print');
    setIsPrinting(mediaQueryList.matches);

    const handleChange = (e: MediaQueryListEvent) => {
      setIsPrinting(e.matches);
    };

    if ('addEventListener' in mediaQueryList) {
      mediaQueryList.addEventListener('change', handleChange);
      return () => mediaQueryList.removeEventListener('change', handleChange);
    } else if ('addListener' in mediaQueryList) {
      // Fallback for older browsers (e.g. Safari < 14) where MediaQueryList uses addListener/removeListener
      mediaQueryList.addListener(handleChange);
      return () => mediaQueryList.removeListener(handleChange);
    }
  }, []);

  return { isPrinting };
}

export default useIsPrinting;
